declare global {
  interface Window {
    lwhb:
      | {
          load: (ad: Element) => void;
          loaded: boolean;
          cmd: Array<() => void>;
        }
      | undefined;
  }
}

function handleLoadAdInDevelopment(el: HTMLElement) {
  console.log('DEVELOPMENT: loading FAKE ad: ', el.dataset.tid);
  const txsParent = el.parentElement;
  if (txsParent?.classList.contains('txs-a')) {
    el.innerText = el.attributes.getNamedItem('data-tid')?.value ?? 'unknown';
  }
}

function loadAd(el: HTMLElement) {
  if (process.env.NODE_ENV === 'development') {
    handleLoadAdInDevelopment(el);
  } else {
    if (window.lwhb?.loaded) {
      window.lwhb.load(el);
    } else {
      window.lwhb?.cmd.push(() => window.lwhb?.load(el));
    }
  }
}

function isFullpageAd(el: HTMLElement): boolean {
  return el.dataset.tid?.includes('helsida') ?? false;
}

// Matches the CSS breakpoint: mb-only max-width 48em, dt-only min-width 49em
const DESKTOP_BREAKPOINT = 784; // 49em * 16px

function matchesViewport(el: HTMLElement): boolean {
  const isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
  if (el.classList.contains('mb') && isDesktop) return false;
  if (el.classList.contains('dt') && !isDesktop) return false;
  return true;
}

function createLeeAdObserver() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (
            entry.target instanceof HTMLElement &&
            entry.target?.dataset.custom === 'true' &&
            entry.target?.dataset.pbid
          ) {
            loadAd(entry.target);
            observer.unobserve(entry.target);
          }
        }
      });
    },
    {
      root: null,
      rootMargin: '600px',
    },
  );
  return {
    add: (nodes) => {
      nodes =
        Array.isArray(nodes) || nodes instanceof NodeList
          ? [...nodes]
          : [nodes];

      nodes.forEach((ad) => {
        if (ad.dataset.custom === 'true') {
          // Fullpage ads have display:none so IntersectionObserver will never fire — load immediately.
          // matchesViewport prevents loading e.g. mobile fullpage on desktop.
          // Regular ads don't need this check — CSS hides them and the observer never fires.
          if (isFullpageAd(ad)) {
            if (matchesViewport(ad)) loadAd(ad);
          } else {
            observer.observe(ad);
          }
        }
      });
    },
  };
}

export default createLeeAdObserver;
